<template>
  <div class="members">
    <h1 v-bg-typography="'h1'">Members</h1>
    <bg-list
      v-if="!isLoading"
      @actionClick="handleActions"
      :headers="headers"
      :items="items"
      :actions="actions"
      :admin="userState.user.role === 'company_admin'"
    />
    <bg-loader :dark="true" v-if="isLoading"></bg-loader>
    <bg-modal
      v-if="isModalOpen"
      body="Are you sure you want to remove this user?"
      @close="isModalOpen = false"
    >
      <bg-button
        variant="secondary"
        text="Cancel"
        @click="isModalOpen = false"
      />
      <bg-button
        variant="destructive"
        class="action"
        text="Delete"
        @click="deleteMember"
      />
    </bg-modal>
  </div>
</template>

<script>
import BgList from "@/components/bg-list";
import BgTypography from "@/directives/bg-typography";
import BgModal from "@/components/bg-modal";
import BgButton from "@/components/bg-button";
import BgLoader from "@/components/bg-loader";
import moment from "moment";

import API from "@/api";
import { mapState } from "vuex";

export default {
  name: "members",
  components: {
    BgModal,
    BgList,
    BgButton,
    BgLoader,
  },
  directives: {
    BgTypography,
  },
  async mounted() {
    this.loadMembers();
  },
  computed: {
    ...mapState({
      userState: (state) => state.user,
    }),
  },
  methods: {
    handleActions(user) {
      if (user.actionType === "delete") {
        this.isModalOpen = true;
        this.userToDelete = user.id;
      }
      if (user.actionType === "edit") {
        this.$router.push({ path: `/edit-member/${user.id}` });
      }
    },
    async deleteMember() {
      this.isLoading = true;
      this.isModalOpen = false;
      const res = await API.user.deleteUser(this.userToDelete);
      this.loadMembers();
    },
    async loadMembers() {
      this.isLoading = true;
      const data = await API.user.getCompanyUsers(
        this.userState.user.company.id
      );
      this.items = data.users.map((u) => {
        return {
          ...u,
          fullname: !u.profile.first_name
            ? ""
            : u.profile.first_name + " " + u.profile.last_name,
        };
      });
      this.isLoading = false;
    },
  },
  data() {
    return {
      isLoading: true,
      isModalOpen: false,
      headers: [
        { label: "Member name", value: "fullname", icon: "account" },
        { label: "Role", value: "role", format: (value) => this.roles[value] },
        { label: "Email", value: "email" },
        {
          label: "Last login",
          value: "last_login",
          format: (value) =>
            value === 0 ? "" : moment.unix(value).format("DD/MM/YY"),
        },
      ],
      roles: {
        company_admin: "Admin",
        company_member: "Member",
        admin: "Super Admin",
      },
      items: [],
      actions: [
        {
          type: "edit",
          icon: "edit",
          tooltip: "Edit member",
        },
        {
          type: "delete",
          icon: "trashcan",
          tooltip: "Delete member",
        },
      ],
    };
  },
};
</script>
